import styled, { keyframes, css } from "styled-components";
const fadeInAnimation = keyframes`
   0% {
     opacity: 0;
     max-height: 0px;
   }
   100% {
     opacity: 1;
     max-height: 40px;
   }
`;

const baseTableStyle = css`
  font-size: var(--font-size-sm);
  color: #1c3542;
  transition: all 1s ease-in-out;
  @media screen and (max-width: 400px) {
    font-size: var(--font-size-xs);
  }
`;

export const StyledTable = styled.table`
  transition: all 1s ease-in-out;
  td{
    padding:0.3rem 0rem;
  }
  td:first-child {
    font-weight: 500;
    min-width: 90px;
    padding-left:1.6rem;
    ${baseTableStyle};
  }
  td:last-child {
    ${baseTableStyle}
  }
  .price-td {
    font-size: var(--font-size-base);
    color: var(--blue-color-dark);
    text-align: end;
  }
  .discount-td {
    font-size: var(--font-size-base);
    color: var(--danger-color);
    text-align: end;
  }
  .tax-td {
    font-size: var(--font-size-base);
    color: var(--success-color);
    text-align: end;
  }
  .wallet-information {
    font-size: var(--font-size-sm);
    display: none;
  }
  .fade-in {
    animation-name: ${fadeInAnimation};
    animation-duration: 1s;
    display: table-row;
  }
  .fade-out {
    opacity: 0;
    transition: all 1s ease-in-out;
  }
  tr:last-child {
    height: 50px;
    border-top: 1px solid var(--field-color);
    transition: all 1s ease-in-out;
    td:first-child {
      font-weight: 500;
      font-size: var(--font-size-sm);
      @media screen and (max-width: 400px) {
        font-size: var(--font-size-xs);
      }
    }
    td:nth-child(2) {
      font-weight: 500;
      font-size: var(--font-size-md);
      color: var(--blue-color-dark);
    }
  }
`;
